import RestAPI from 'components/Common/restApi';

export type CreditCardsListResponseItem = {
  brand: string;
  expired_date: string;
  name_on_card: string;
  id: number;
  uuid: string;
  last4: number;
  primary: boolean;
  zip: string;
};

export type CreditCardsListResponse = CreditCardsListResponseItem[];

export type AddCreditCardParams = {
  stripe_card_token: string;
  primary: boolean;
};

export type AddCreditCardResponse = {
  message: string;
};

export type UpdateCreditCardParams = {
  name_on_card?: string;
  exp_month?: number;
  exp_year?: number;
  zip?: string;
};

export type CREDIT_CARDS_API_VERSION = '1' | '2';

export default class CreditCardsAdminApi {
  version: CREDIT_CARDS_API_VERSION;

  constructor(useUUIDs: boolean) {
    this.version = useUUIDs ? '2' : '1';
  }

  private get apiVariant() {
    return this.version === '2' ? 'credit_cards_v2' : 'credit_cards';
  }

  getCreditCards(organizationId: number) {
    return RestAPI.get<CreditCardsListResponse>(`/alpha/admin/organizations/${organizationId}/${this.apiVariant}`);
  }

  add(organizationId: number, data: AddCreditCardParams, source: string) {
    return RestAPI.postWithCustomHeaders<AddCreditCardResponse, AddCreditCardParams>(
      `/alpha/admin/organizations/${organizationId}/${this.apiVariant}`,
      { source },
      data
    );
  }

  update(organizationId: number, cardId: number | string, data: UpdateCreditCardParams, source: string) {
    return RestAPI.putWithCustomHeaders<AddCreditCardResponse, UpdateCreditCardParams>(
      `/alpha/admin/organizations/${organizationId}/${this.apiVariant}/${cardId}`,
      {
        source,
      },
      data
    );
  }

  delete(organizationId: number, cardId: number | string, source: string) {
    return RestAPI.deleteWithCustomHeaders(
      `/alpha/admin/organizations/${organizationId}/${this.apiVariant}/${cardId}`,
      {
        source,
      },
      {}
    );
  }

  setAsPrimary(organizationId: number, cardId: number | string, source: string) {
    return RestAPI.putWithCustomHeaders(
      `/alpha/admin/organizations/${organizationId}/${this.apiVariant}/${cardId}/mark_as_primary`,
      {
        source,
      },
      {}
    );
  }
}
